import "core-js/modules/es6.array.map";
import o from "react";

var s = function s(_ref) {
  var a = _ref.sitemapLinks;
  return o.createElement("ul", {
    className: "hg-global-footer__sitemap-links"
  }, a.map(function (l, i) {
    return o.createElement("li", {
      key: i,
      id: l.id
    }, o.createElement("a", {
      href: l.url,
      className: "hg-global-footer__sitemap-link"
    }, l.label));
  }));
};

export { s as SitemapLinks };